import { useEffect, useRef } from 'react'
import { Ad } from "../../interface/Ad"

interface AdViewProps {
  ad: Ad
  show: boolean
  didLoad: () => void
  didMeasureVideoDuration: Function
}

export default function AdView({ ad, show, didLoad, didMeasureVideoDuration }: AdViewProps) {
  const videoRef: any = useRef(null);

  const play = () => {
    if (!videoRef || !videoRef.current) return
    
    videoRef.current.currentTime = 0;
    videoRef.current.play()
  }

  const stop = () => {
    if (!videoRef || !videoRef.current) return

    videoRef.current.pause()
  }

  useEffect(() => {
    show ? play() : stop()
  }, [show])

  if (ad.mime_type.includes("video/")) {
    return (
      <video
        muted
        playsInline
        src={ad.path}
        ref={videoRef}
        onDurationChange={(e: any) => didMeasureVideoDuration(e.target.duration)}
        className={`slide ${show ? "windmillShow" : "windmillHide"}`}
        onCanPlayThrough={didLoad}
        onError={didLoad}
      />
    )
  }

  return (
    <img
      src={ad.path}
      alt="Full-screen slide"
      className={`slide ${show ? "windmillShow" : "windmillHide"}`}
      onLoad={didLoad}
      onError={didLoad}
    />
  )
}